
import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

interface AnimatedSubmitButtonProps {
  isSubmitting: boolean;
  onSubmit: () => void;
  className?: string;
}

const evaluationSteps = [
  "Evaluating your essay...",
  "Checking task achievement...",
  "Analyzing coherence and cohesion...",
  "Reviewing vocabulary usage...",
  "Checking your grammar...",
];

export const AnimatedSubmitButton = ({
  isSubmitting,
  onSubmit,
  className,
}: AnimatedSubmitButtonProps) => {
  const [currentStep, setCurrentStep] = useState(0);

  useEffect(() => {
    if (!isSubmitting) {
      setCurrentStep(0);
      return;
    }

    const interval = setInterval(() => {
      setCurrentStep((prev) => (prev + 1) % evaluationSteps.length);
    }, 2000);

    return () => clearInterval(interval);
  }, [isSubmitting]);

  return (
    <Button
      onClick={onSubmit}
      disabled={isSubmitting}
      className={cn(
        "transition-all duration-300 relative",
        isSubmitting && "w-full justify-center",
        className
      )}
    >
      {isSubmitting ? (
        <div className="flex items-center gap-2">
          <Loader2 className="h-4 w-4 animate-spin" />
          <span className="animate-fade-in">
            {evaluationSteps[currentStep]}
          </span>
        </div>
      ) : (
        "Submit for Evaluation"
      )}
    </Button>
  );
};
